var _a;
import { EActionState, createCustomAction } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./card.constants";
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["MarkAllAsRead"] = "MARK_ALL_AS_READ";
})(EActionCustom || (EActionCustom = {}));
var generateMarkAllAsReadActions = function () { return ({
    markAllAsReadStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.MarkAllAsRead,
        state: EActionState.Start,
    }),
    markAllAsReadSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.MarkAllAsRead,
        state: EActionState.Success,
    }),
    markAllAsReadFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.MarkAllAsRead,
        state: EActionState.Fail,
    }),
}); };
export var markAllAsReadStart = (_a = generateMarkAllAsReadActions(), _a.markAllAsReadStart), markAllAsReadSucceeded = _a.markAllAsReadSucceeded, markAllAsReadFailed = _a.markAllAsReadFailed;
